export default __webpack_public_path__ + "static/media/stamper-grey.6c081a81.png";